module.exports = __webpack_public_path__ + "static/img/bigdata6.f9f40e7.png";


//////////////////
// WEBPACK FOOTER
// ./public/hadoopImg/bigdata6.png
// module id = FG18
// module chunks = 0